export enum RouteEvents {
  GuardsCheckEnd = 'onBefore',
  GuardsCheckStart = 'onBefore',
  NavigationStart = 'onStart',
  ResolveStart = 'onExit',
  RoutesRecognized = 'onRetain',
  NavigationCancel = 'onError',
  NavigationError = 'onError',
  ResolveEnd = 'onSuccess',
  NavigationEnd = 'onFinish'

}
